import api from "./api";

/**
 * Lisans/abonelik aktifleştirme talepleri (backend: /api/subscription-requests).
 * Yönetici lisansını doğrudan aktifleştiremez: paket seçip talep oluşturur
 * (PENDING); admin ödemeyi manuel doğrulayıp onaylayınca lisans aktifleşir.
 * Yanıtlar ApiResponse zarfında gelir (res.data.data).
 */
export const subscriptionRequestService = {
  /** Yönetici (veya admin) yeni talep oluşturur. */
  create: (payload) => api.post("/subscription-requests", payload),
  /** ADMIN: onay bekleyen tüm talepler. */
  listPending: () => api.get("/subscription-requests/pending"),
  /** Bir salonun talep geçmişi (sahip veya admin). */
  listForSalon: (salonId) => api.get(`/subscription-requests/salon/${salonId}`),
  /** ADMIN: ödeme doğrulandı → onayla ve lisansı aktifleştir. */
  approve: (id, adminNote) => api.post(`/subscription-requests/${id}/approve`, { adminNote: adminNote ?? null }),
  /** ADMIN: talebi reddet. */
  reject: (id, adminNote) => api.post(`/subscription-requests/${id}/reject`, { adminNote: adminNote ?? null }),
};

/** Talep durumu çipi (backend: SubscriptionRequestStatus). */
export const SUBSCRIPTION_REQUEST_STATUS = {
  PENDING: { label: "Onay Bekliyor", tone: "warning" },
  APPROVED: { label: "Onaylandı", tone: "success" },
  REJECTED: { label: "Reddedildi", tone: "error" },
};
